import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatStepper } from '@angular/material/stepper';


@Component({
  selector: 'calsoft-timeline',
  templateUrl: './timeline.component.html',
  styleUrls: ['./timeline.component.scss']
})
export class TimelineComponent implements OnInit {

  @ViewChild('stepper', { static: true }) stepper: MatStepper;
  @Input() value: any;
  stepperMode:any='horizontal'
  constructor() { }
 
  ngOnInit(): void {

    if (window.innerWidth>959) {
      this.stepperMode = 'horizontal';
    } else {
      this.stepperMode = 'vertical';
    }

    if(this.value=='Pending'){
      this.stepper.selectedIndex=0
    }else if(this.value=='Shipped'){
      this.stepper.selectedIndex=1
    }else{
      this.stepper.selectedIndex=2
    }
   
  }


}
